var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-selector",class:{ 'selector-disabled': _vm.disabled },attrs:{"tabindex":_vm.tabindex},on:{"blur":function($event){_vm.open = false}}},[_c('div',{staticClass:"selected",class:{ open: _vm.open },on:{"click":function($event){_vm.open = !_vm.open}}},[_vm._v(" "+_vm._s(_vm.selected.name || _vm.placeholder)+" ")]),_c('div',{staticClass:"items",class:{ selectHide: !_vm.open }},_vm._l((_vm.options),function(option,i){return _c('div',{key:i,on:{"click":function($event){if (!_vm.disabled) {
					_vm.selected = option;
					_vm.open = false;
					_vm.$emit('input', option);
				}}}},[_vm._v(" "+_vm._s(option.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }